(function () {
  let initialized = false;

  function initCouponScript() {
    if (initialized) return;
    if (!window.CouponCodeManager) return;

    const input = document.getElementById('ec-cupom-input');
    if (!input) return;
    initialized = true;

    const button = document.getElementById('ec-apply-coupon-button');
    const badges = document.getElementById('ec-coupon-badges');
    const message = document.getElementById('ec-coupon-message');
    if (!input || !button || !badges) return;

    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function renderBadges(coupons) {
      if (!coupons || coupons.length === 0) {
        badges.innerHTML = '';
        return;
      }
      const checkUrl = badges.getAttribute('data-check-icon-url') || '';
      badges.innerHTML = `
        <ul class="ec-discounts-list" role="list">
          ${coupons
            .map(
              (coupon) => `
            <li class="ec-coupon-badge" data-coupon-code="${escapeHtml(coupon)}" data-remove-discount>
              <span class="ec-coupon-badge__icon" aria-hidden="true">
                ${checkUrl ? '<img src="' + checkUrl.replace(/"/g, '&quot;') + '" alt="" width="20" height="20">' : ''}
              </span>
              <span class="ec-coupon-badge__text">O cupom (${escapeHtml(coupon)}) foi aplicado com sucesso.</span>
              <button
                type="button"
                class="ec-coupon-badge__remove"
                aria-label="Remover cupom"
              >Remover</button>
            </li>
          `,
            )
            .join('')}
        </ul>
      `;
      badges.querySelectorAll('.ec-coupon-badge__remove').forEach((btn) => {
        btn.addEventListener('click', function () {
          const badge = btn.closest('[data-coupon-code]');
          const codeToRemove = badge.getAttribute('data-coupon-code');
          removeCoupon(codeToRemove);
        });
      });
    }

    function formatMoney(cents) {
      const val = parseFloat(cents);
      if (isNaN(val) || !isFinite(val)) {
        return 'R$ 0,00';
      }
      return 'R$ ' + (val / 100).toFixed(2).replace('.', ',');
    }

    function updateCartSummary(cart) {
      const subtotalEl = document.getElementById('ec-cart-subtotal');
      const totalEl = document.getElementById('ec-cart-total-value');
      const couponLineEl = document.getElementById('ec-cart-footer-coupon-line');
      const couponValueEl = document.getElementById('ec-cart-coupon-value');
      if (subtotalEl && cart && cart.total_price != null) {
        const subtotal = (cart.total_price || 0) + (cart.total_discount || 0);
        subtotalEl.textContent = formatMoney(subtotal);
      }
      if (totalEl && cart && cart.total_price != null) {
        totalEl.textContent = formatMoney(cart.total_price);
      }
      if (couponLineEl && couponValueEl && cart) {
        if (cart.total_discount && cart.total_discount > 0) {
          couponLineEl.style.display = 'flex';
          couponValueEl.textContent = '- ' + formatMoney(cart.total_discount);
          couponValueEl.style.color = '#1a7f37';
        } else {
          couponLineEl.style.display = 'none';
        }
      }
    }

    let messageTimeout = null;
    function showMessage(text, type) {
      if (messageTimeout) {
        clearTimeout(messageTimeout);
        messageTimeout = null;
      }
      if (!message) return;
      message.style.display = 'block';
      message.textContent = text;
      message.className = 'ec-coupon-message ec-coupon-message--' + type;
      if (type !== 'loading') {
        messageTimeout = setTimeout(() => {
          message.style.display = 'none';
          message.innerHTML = '';
          messageTimeout = null;
        }, 4000);
      }
    }

    function applyCoupon() {
      const code = input.value.trim();
      if (!code) {
        showMessage('Digite um código de cupom.', 'error');
        return;
      }

      button.disabled = true;
      button.innerHTML = '<span class="ec-spinner"></span>';
      showMessage('Aplicando cupom...', 'loading');

      window.CouponCodeManager.applyDiscount(code)
        .then((cartAfter) => {
          const isApplicable = window.CouponCodeManager.isCouponApplicable(cartAfter, code);
          const appliedCoupons = window.CouponCodeManager.getAppliedCoupons(cartAfter);

          if (isApplicable) {
            renderBadges(appliedCoupons);
            updateCartSummary(cartAfter);
            input.value = '';
            if (message) {
              message.style.display = 'none';
              message.innerHTML = '';
            }
            document.dispatchEvent(
              new CustomEvent('cart:updated', { detail: cartAfter })
            );
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ec-cart-coupon', cartData: cartAfter });
            }
          } else {
            window.CouponCodeManager.removeDiscount()
              .then((cartRestored) => {
                const restoredCoupons = window.CouponCodeManager.getAppliedCoupons(cartRestored);
                renderBadges(restoredCoupons);
                updateCartSummary(cartRestored);
                document.dispatchEvent(
                  new CustomEvent('cart:updated', { detail: cartRestored })
                );
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ec-cart-coupon' });
                }
              });
            showMessage('Cupom inválido ou não aplicável.', 'error');
          }
        })
        .catch((err) => {
          showMessage('Erro ao aplicar o cupom.', 'error');
        })
        .finally(() => {
          button.disabled = false;
          button.innerHTML = 'Usar cupom';
        });
    }

    function removeCoupon(codeToRemove) {
      if (message) {
        message.style.display = 'block';
        message.textContent = 'Removendo cupom...';
        message.className = 'ec-coupon-message ec-coupon-message--loading';
      }
      if (button) {
        button.disabled = true;
        button.innerHTML = '<span class="ec-spinner"></span>';
      }

      window.CouponCodeManager.removeDiscount()
        .then((cart) => {
          const appliedCoupons = window.CouponCodeManager.getAppliedCoupons(cart);
          renderBadges(appliedCoupons);
          updateCartSummary(cart);
          if (message) {
            message.style.display = 'none';
            message.innerHTML = '';
          }
          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: cart })
          );
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ec-cart-coupon' });
          }
        })
        .catch(() => {
          if (message) {
            message.textContent = 'Erro ao remover o cupom.';
            message.className = 'ec-coupon-message ec-coupon-message--error';
          }
        })
        .finally(() => {
          if (button) {
            button.disabled = false;
            button.innerHTML = 'Usar cupom';
          }
        });
    }

    function initBadges() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then((res) => res.json())
        .then((cart) => {
          const appliedCoupons = window.CouponCodeManager.getAppliedCoupons(cart);
          if (appliedCoupons.length > 0) {
            renderBadges(appliedCoupons);
          }
          updateCartSummary(cart);
        })
        .catch(() => {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBadges);
    } else {
      initBadges();
    }

    button.addEventListener('click', applyCoupon);

    document.addEventListener('click', function (event) {
      const removeButton = event.target.closest('[data-remove-discount] button');
      if (!removeButton) return;
      event.preventDefault();
      const badge = removeButton.closest('[data-coupon-code]');
      if (!badge) return;
      const codeToRemove = badge.getAttribute('data-coupon-code');
      if (codeToRemove) {
        removeCoupon(codeToRemove);
      }
    });

    document.addEventListener('cart:updated', function (event) {
      if (event.detail) {
        updateCartSummary(event.detail);
      }
    });
  }

  if (!window.__EC_CART_COUPON_OBSERVED) {
    window.__EC_CART_COUPON_OBSERVED = true;
    const observer = new MutationObserver(() => {
      initCouponScript();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  initCouponScript();
})();
